import { graphql } from "../../generated";

export const MUTATE_COMIC = graphql(`
  mutation MutateComic(
    $comicId: Int!
    $addAnimationUrl: String
    $columns: Int
  ) {
    mutateComic(
      comicId: $comicId
      addAnimationUrl: $addAnimationUrl
      columns: $columns
    ) {
      id
      columns
      frames {
        id
        animation {
          ...CoreAnimationFields
        }
        sequence
        rowSpan
        colSpan
      }
    }
  }
`);
